export const TrafficType = Object.freeze({
    LOGGED_OUT: 'logged_out',
    USER: 'user',
});

export const FeatureFlag = Object.freeze({
    DRIVER_TIPS_OPTIONAL_COPY: 'driver-tips-optional-copy',
    HIDE_BIWEEKLY_FOR_NEW_SIGNUPS: 'hide-biweekly-for-new-signups',
    MEMBERSHIP: 'membership',
    MOBILE_PAYMENT_CTA: 'mobile-payment-cta',
    REORDER_EXPERIENCE_BUY_IT_AGAIN: 'reorder-experience-buy-it-again',
    UP_SELLS_CAROUSEL_PLP: 'upsells-carousel-plp',
    UP_SELLS_CAROUSEL_PDP: 'upsells-carousel-pdp',
});

export const LOGGED_OUT_FEATURE_FLAGS = [FeatureFlag.MOBILE_PAYMENT_CTA];

export const USER_FEATURE_FLAGS = [
    FeatureFlag.DRIVER_TIPS_OPTIONAL_COPY,
    FeatureFlag.HIDE_BIWEEKLY_FOR_NEW_SIGNUPS,
    FeatureFlag.REORDER_EXPERIENCE_BUY_IT_AGAIN,
    FeatureFlag.UP_SELLS_CAROUSEL_PLP,
    FeatureFlag.UP_SELLS_CAROUSEL_PDP,
];
